module.exports = "/_next/static/images/AWSCDSriLanka2-fbdd06b4922ca5f10e531a99fe2b411d.jpg";